import { Avatar, Grid, styled } from "@mui/material";
import HCheckArray from "../../../../../helpers/check-have-value";
import { memo } from "react";
import MxCImageCarousel from "./MxCImageCarousel";

interface MxCPropertyPictureProps {
  pictures: string[];
  onClick?: () => void;
}

const MxCPropertyPicture = memo((props: MxCPropertyPictureProps) => {
  if (!HCheckArray(props.pictures))
    return (
      <ContentPicture className="content-picture">
        <CustomPicture alt="R" variant="square" onClick={props.onClick} />
      </ContentPicture>
    );

  return (
    <ContentPicture className="content-picture">
      <MxCImageCarousel
        images={props.pictures}
        onClick={props.onClick}
        showIndicators={false}
        renderItem={(image, index) => (
          <CustomPicture
            key={image}
            alt={`Imagen ${index + 1}`}
            src={image}
            variant="rounded"
            onClick={props.onClick}
          />
        )}
      />
    </ContentPicture>
  );
});

export default MxCPropertyPicture;

MxCPropertyPicture.displayName = "MxCPropertyPicture";

const ContentPicture = styled(Grid)(({ theme }) => ({
  width: "100%",
  minHeight: 180,
  [theme.breakpoints.only("sm")]: {
    minHeight: 165
  },
  [theme.breakpoints.only("md")]: {
    minHeight: 175
  }
}));

const CustomPicture = styled(Avatar)(({ theme }) => ({
  width: "100%",
  height: 180,
  flexShrink: 0,
  [theme.breakpoints.only("sm")]: {
    height: 165
  },
  [theme.breakpoints.only("md")]: {
    height: 175
  },
  [theme.breakpoints.only("lg")]: {
    height: 185
  },
  [theme.breakpoints.only("xl")]: {
    height: 195
  }
}));
